import { render, staticRenderFns } from "./WasteList.vue?vue&type=template&id=49413be0&"
import script from "./WasteList.vue?vue&type=script&lang=js&"
export * from "./WasteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports